import { Channel } from '../types/common';
import tracking from '../utils/tracking';

export const referralPageAttempt = (member: boolean): void => {
  tracking.event('Referral Page Attempted', {
    member: member,
  });
};

export const referralRegisterStarted = (authenticated: boolean): void => {
  tracking.event('Referral register started', {
    member: authenticated,
  });
};

export const referralSharedLinkOpened = (referralCode = ''): void => {
  tracking.event('Referral shared link opened', {
    referral_code: referralCode,
  });
};

export const referralShared = (channel: Channel, referralCode = ''): void => {
  tracking.event('Referral Shared Link clicked', {
    channel,
    referral_code: referralCode,
  });
};

export const referralPageViewed = (member: boolean): void => {
  tracking.event('Referral page viewed', {
    member: member,
  });
};
